// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1328":"145211df","3267":"71bc6a9b","8689":"31d6cfe0"}[chunkId] + ".chunk.css";
};